<div class="body">
    
    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">image_search</mat-icon>
        <span>
            Bild auswählen
        </span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content-wrapper">

        <ng-container *ngIf="!croppedImage; else preview">

            <input *ngIf="fileUploaded" type="range" min="0" max="9" step=".01" (input)="transformScale = $event.target.value" value="transformScale" />
    
            <div class="cropper-wrapper" >
    
                <image-cropper 
                    [imageBase64]="image64" 
                    [maintainAspectRatio]="true" 
                    [aspectRatio]="1" 
                    format="mediaType" 
                    [resizeToWidth]="maxWidth"
                    [transform]="transform" 
                    [autoCrop]="false" 
                    (imageCropped)="imageCropped($event)" 
                    [cropper]="tempCropper"
                ></image-cropper>
    
            </div>

        </ng-container>

        <ng-template #preview>

            <div class="image-preview" #previewImage>

                <div class="spacer"></div>

                <img [src]="croppedImage" />

                <div class="spacer"></div>

            </div>

        </ng-template>

    </div>

    <div class="footer">

        <input type="file" multiple=false (change)="fileChangeEvent($event)" accept="image/png,image/jpeg" />

        <ng-container *ngIf="fileUploaded">

            <button *ngIf="!croppedImage" mat-raised-button (click)="cropImage()">
                Auswahl übernehmen
            </button>

            <ng-container *ngIf="croppedImage">

                <button mat-raised-button color="warn" (click)="switchToCroppingMode()">
                    Ändern
                </button>
    
                <button mat-raised-button color="primary" (click)="confirm()" *ngIf="containsChanges">
                    Speichern
                </button>
    
            </ng-container>

        </ng-container>

    </div>

    <ng-container *ngIf="isProceeding">

        <div class="overlay">

            <div class="spacer"></div>
            <mat-spinner [diameter]="60"></mat-spinner>
            <div class="spacer"></div>

        </div>

    </ng-container>

</div>